import * as React from 'react';

import { EvalState, ProgressStateModel, TicketState } from 'eTip--common';

import { ProgressContent, TicketListStateIcon } from 'common--design-library';

import { translationForMts, currencyFormatter, DateFormat, TimeFormat, dateFormatter, pointsFormatter } from 'easit--localization';
import { NoResultsEmptyList } from '../noResults/noResults';


export interface ITicketListItem {
    id: number;
    number: string;
    placementDate: Date;
    stake: number;
    stakePoints: number | null;
    potentialWin: number;
    prizeEval: number | null;
    evalState: EvalState;
    ticketState: TicketState;
}

export interface ITicketListProps {
    tickets: ITicketListItem[];
    state: ProgressStateModel;
    error: string;
    pager: React.ReactNode;
    canShowTicketNumber: boolean;
    canShowPotentialWin: boolean;
    onGoToDetail: (id: string) => void;
}


export const TicketList: React.FC<ITicketListProps> = (props) => {
    const t = translationForMts();
    const winColumnLabelParts: string[] = t.betList_ColumnPricePotentialPrice.split('/');
    const testRoleMainPart = "ticket-list";

    return (
        <>
            {
                props.tickets.length > 0 &&
                <table className="cashout-list ticket-list" data-test-role={testRoleMainPart}>
                    <thead>
                        <tr>
                            {props.canShowTicketNumber && <th>{t.betList_TicketNumber}</th>}
                            <th>{t.betList_ColumnTime}</th>
                            <th>{t.betList_ColumnStake}</th>
                            <th className="win-column">{props.canShowPotentialWin ? <> {winColumnLabelParts[0]} <br />{winColumnLabelParts[1]} </> : winColumnLabelParts[1]} </th>
                            <th>{t.betList_ColumnStatus}</th>
                            <th>{t.betList_ColumnDetail}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            props.tickets.map(ticket => <tr key={ticket.id} className="cursor-pointer" onClick={() => { props.onGoToDetail(`${ticket.id}`) }} data-test-role={`${testRoleMainPart}__item`}>
                                {props.canShowTicketNumber && <td>{ticket.number}</td>}
                                <td>
                                    {dateFormatter.formatDateAsRelative(ticket.placementDate, DateFormat.DDMMYY, true)} <br />
                                    {dateFormatter.formatTime(ticket.placementDate, TimeFormat.HHMM)}
                                </td>
                                <td>
                                    {currencyFormatter.format(ticket.stake)}
                                    {ticket.stakePoints > 0 && <><br />{pointsFormatter.format(ticket.stakePoints)}</>}</td>
                                <td>{ticket.potentialWin >= 0 /* virt games 0 shown for lost */ && currencyFormatter.format(ticket.potentialWin)}{!!ticket.prizeEval && <><br />{currencyFormatter.format(ticket.prizeEval)}</>}</td>
                                <td className="bet-state"><TicketListStateIcon ticketState={ticket.ticketState} evalState={ticket.evalState} /></td>
                                <td><span className="fa fa-search nav-link"></span></td>
                            </tr>)
                        }
                    </tbody>
                </table>
            }
            {
                <ProgressContent state={props.state} errorMessage={props.error}>
                    {
                        props.tickets.length > 0 && props.pager
                    }
                    {
                        props.tickets.length === 0 &&
                        <NoResultsEmptyList message={t.myTickets_NoTicket} testRoleMainPart={testRoleMainPart} />
                    }
                </ProgressContent>
            }
        </>
    )

}